import { render } from "./TickMark.vue?vue&type=template&id=3ffb3304&scoped=true"
const script = {}

import "./TickMark.vue?vue&type=style&index=0&id=3ffb3304&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffb3304"]])

export default __exports__